import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getUsers as getUsersApi,
  addNewUser as addNewUserApi,
  addNewEmployee as addNewEmployeeApi,
  updateUser as updateUserApi,
  updateEmployee as updateEmployeeApi,
  deleteUser as deleteUserApi,
  heartbeatUser as heartbeatUserApi,
  changePassword as changePasswordApi,
  uploadPDFs as uploadPDFsApi,
  uploadPDFsTransport as uploadPDFsTransportApi,
  getFiles as getFilesApi,
  getFilesTransport as getFilesTransportApi,
  deleteFile as deleteFileApi,
  updateFiles as updateFilesApi,
  getExchangeRates as getExchangeRatesApi,
} from "../../helpers/realbackend_helper";

export const getUsers = createAsyncThunk("crm/getUsers", async () => {
  try {
    const response = await getUsersApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewUser = createAsyncThunk(
  "crm/addNewUser",
  async (contact) => {
    try {
      const response = addNewUserApi(contact);
      toast.success("Шинэ хэрэглэгчийн мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Шинэ хэрэглэгчийн мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const addNewEmployee = createAsyncThunk(
  "crm/addNewEmployee",
  async (contact) => {
    try {
      const response = addNewEmployeeApi(contact);
      toast.success("Шинэ ажилтны мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Шинэ ажилтны мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const changePassword = createAsyncThunk(
  "crm/changePassword",
  async (contact, { rejectWithValue }) => {
    try {
      const response = await changePasswordApi(contact);

      toast.success("Нууц үг амжилттай солигдлоо!", {
        autoClose: 3000,
      });

      return response;
    } catch (error) {
      toast.error("Хуучин нууц үг буруу байна!", {
        autoClose: 3000,
      });

      return rejectWithValue(error.response?.data || "Амжилтгүй боллоо");
    }
  }
);

export const updateUser = createAsyncThunk(
  "crm/updateUser",
  async (contact) => {
    try {
      const response = updateUserApi(contact);
      toast.success("Хэрэглэгчийн мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Хэрэглэгчийн мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "crm/updateEmployee",
  async (contact) => {
    try {
      const response = updateEmployeeApi(contact);
      toast.success("Ажилтны мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Ажилтны мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const heartbeatUser = createAsyncThunk(
  "crm/heartbeatUser",
  async (contact) => {
    try {
      const response = heartbeatUserApi(contact);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteUser = createAsyncThunk(
  "crm/deleteUser",
  async (contact) => {
    try {
      const response = deleteUserApi(contact);
      toast.success("Ажилтны мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { contact, ...response };
    } catch (error) {
      toast.error("Ажилтны мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

// Upload PDFs
export const uploadPDFs = createAsyncThunk(
  "crm/uploadPDFs",
  async ({ pdfFiles, category, uploadedBy }, { rejectWithValue }) => {
    // console.log("=== uploadPDFs thunk called ===");
    // console.log("Files to upload:", pdfFiles);
    // console.log("Category:", category);
    // console.log("Uploaded by:", uploadedBy);

    try {
      const res = await uploadPDFsApi({ pdfFiles, category, uploadedBy });
      //console.log("Upload response:", res);

      // res is the JSON returned from backend
      return res.files || [];
    } catch (err) {
      console.error("Upload failed in thunk:", err);
      return rejectWithValue(err.response?.data || err.message || err);
    }
  }
);

export const uploadPDFsTransport = createAsyncThunk(
  "crm/uploadPDFsTransport",
  async ({ pdfFiles, category, uploadedBy, orderId }, { rejectWithValue }) => {
    try {
      const res = await uploadPDFsTransportApi({
        pdfFiles,
        category,
        uploadedBy,
        orderId,
      });

      return res.files || [];
    } catch (err) {
      console.error("Upload failed in thunk:", err);
      return rejectWithValue(err.response?.data || err.message || err);
    }
  }
);

export const updateFiles = createAsyncThunk(
  "crm/updateFiles",
  async (files) => {
    try {
      const response = await updateFilesApi(files);
      toast.success("Файлуудын хандах эрхийг амжилттай тохирууллаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Файлуудын хандах эрхийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const getFiles = createAsyncThunk(
  "crm/getFiles",
  async ({ userId, category }, { rejectWithValue }) => {
    try {
      const files = await getFilesApi({ userId, category });
      return files;
    } catch (err) {
      toast.error("Файлуудыг харуулахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(err.message || "Failed to fetch files");
    }
  }
);

export const getFilesTransport = createAsyncThunk(
  "crm/getFilesTransport",
  async ({ orderId, category }, { rejectWithValue }) => {
    try {
      const files = await getFilesTransportApi({ orderId, category });
      return files;
    } catch (err) {
      toast.error("Файлуудыг харуулахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(err.message || "Failed to fetch files");
    }
  }
);

export const deleteFile = createAsyncThunk(
  "crm/deleteFile",
  async (fileId, { rejectWithValue }) => {
    try {
      await deleteFileApi(fileId); // API call
      toast.success("Файлыг амжилттай устгалаа", { autoClose: 3000 });
      return { fileId }; // Important: return the deleted fileId
    } catch (error) {
      toast.error("Файлыг устгахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getExchangeRates = createAsyncThunk(
  "crm/getExchangeRates",
  async () => {
    try {
      const response = await getExchangeRatesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);
